export class LocalityNew {
  BranchID: number;
  LocalityID: number;
}
